const pathMap = {
  '/': 'home',
  '/home': 'home',
  '/home/': 'home',
  '/hotels': 'hotels',
  '/hotels/': 'hotels',
  '/vacationpackages': 'packages',
  '/vacationpackages/': 'packages',
  '/flights': 'flights',
  '/flights/': 'flights',
  '/insideTrack/flights': 'flights'
} as const

type PathMap = keyof typeof pathMap

function normalizePath(path: string) {
  if (path.startsWith('/insideTrack/flights')) {
    return '/insideTrack/flights'
  }

  return path as PathMap
}

export function isValidPath(path: string): path is PathMap {
  return pathMap[normalizePath(path)] !== undefined
}

/**
 *
 * inside track paths are actually formed like /insideTrack/flights/from_New_York_City-NYC.html
 * so this param is cheating a little
 */
export default function mapPath(path: string) {
  return pathMap[normalizePath(path)]
}
